module.exports = __webpack_public_path__ + "static/img/10.f6339a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/activity2024112/10.png
// module id = 7L13
// module chunks = 0